import styled from 'styled-components'
import { Tag } from '@lmc/ui-kit'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { RotaInstanceStatus } from 'screens/Rostering/types'
import { UserRole } from '@lmc/ts-common'
import { Text } from '@lmc/ui-kit/src/general'

type FilterValue =
  | string
  | string[]
  | boolean
  | RotaInstanceStatus[]
  | UserRole[]

type FilterChipsProps = {
  filters: Array<{ key: string; value: FilterValue }>
  onRemove: any
  onClearAll: () => void
}

export const FilterChips = ({
  filters,
  onRemove,
  onClearAll,
}: FilterChipsProps) => {
  const { t } = useTranslation()

  const allChips = filters.flatMap(({ key, value }) => {
    if (Array.isArray(value)) {
      return value.map((v) => ({ key, value: String(v) }))
    }
    return [{ key, value: String(value) }]
  })

  if (allChips.length === 0) return null

  return (
    <ChipsContainer>
      {allChips.map(({ key, value }) => (
        <StyledTag
          key={`${key}-${value}`}
          closable
          onClose={() => onRemove(key, value)}
        >
          <StyledText level={1.5} weight="medium">
            {value}
          </StyledText>
        </StyledTag>
      ))}
      <ClearButton type="link" onClick={onClearAll}>
        {t('CLEAR_FILTERS')}
      </ClearButton>
    </ChipsContainer>
  )
}

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px 0;
`

const StyledTag = styled(Tag)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  margin: 0;
  background-color: ${({ theme }) => theme.color.neutral.color7};
`

const ClearButton = styled(Button)`
  border: none;
  padding: 0 8px;
  height: 24px;
`
